import { render } from "./ManageMenuView.vue?vue&type=template&id=7abf40f3"
import script from "./ManageMenuView.vue?vue&type=script&lang=js"
export * from "./ManageMenuView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__